import { useTranslation } from 'react-i18next';

export default function NextGenerationSection() {
  const { t } = useTranslation('common');
  
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about-us" className="py-32 px-6 bg-zinc-950">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="order-2 md:order-1">
            <div className="inline-block px-4 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full mb-6">
              <span className="text-amber-500 text-sm font-semibold uppercase tracking-wider">{t('about.badge')}</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 leading-tight">
              {t('about.title')}
            </h2>
            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>
                <strong className="text-white">{t('about.intro')}</strong>
              </p>
              <p>
                {t('about.paragraph1')}
              </p>
              <p>
                {t('about.paragraph2')}
              </p>
              <p>
                {t('about.paragraph3')}
              </p>
              <p>
                {t('about.paragraph4')}
              </p>
            </div>
            <button 
              onClick={() => scrollToSection('contact')}
              className="mt-10 px-8 py-4 bg-white text-black font-semibold rounded-lg hover:bg-amber-500 hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              {t('about.learnMoreBtn')}
            </button>
          </div>

          <div className="order-1 md:order-2">
            <div className="relative w-full h-[500px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/155eec1c1f18abd44c29b463c89dfd62.jpg"
                alt="Next Generation Youth Ministry"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}